import { Col, Container, Row } from 'reactstrap'
import SignInForm from './SignInForm'
import { motion } from 'framer-motion';

export default function SignIn() {
    return (
<div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #021526 0%, #002b3f 50%, #009db5 120%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Poppins', sans-serif",
        position: "relative",
        overflow: "hidden",
        color: "#fff",
      }}
    >
      {/* Soft glowing highlights */}
      <div
        style={{
          position: "absolute",
          width: "450px",
          height: "450px",
          top: "-100px",
          right: "-120px",
          borderRadius: "50%",
          background: "rgba(0,157,181,0.25)",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />
      <div
        style={{
          position: "absolute",
          width: "400px",
          height: "400px",
          bottom: "-100px",
          left: "-100px",
          borderRadius: "50%",
          background: "rgba(0,157,181,0.15)",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      {/* Central container without outer boxes */}
      <Container fluid className="p-0" style={{ position: "relative", zIndex: 1 }}>
        <Row className="m-0 justify-content-center align-items-center">
          <Col xs={12} sm={10} md={6} lg={4} className="p-0 d-flex justify-content-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              style={{
                width: "400px",
                maxWidth: "90%",
                zIndex: 2,
              }}
            >
              <SignInForm />
            </motion.div>
          </Col>
        </Row>
      </Container>
    </div>
    )
}
